import ConnectErrorRecord from "@infinode/records/ConnectErrorRecord";

const CONNECT_ERRORS = {
  401: ConnectErrorRecord({
    errorCode: "401",
    title: "Token Expired",
    message: "You token is expired, please login."
  }),
  403: ConnectErrorRecord({
    errorCode: "403",
    title: "Unauthorized",
    message: "You are not allowed to do the action."
  }),
  404: ConnectErrorRecord({
    errorCode: "404",
    title: "Server cannot find",
    message: "Cannot find the server"
  }),
  405: ConnectErrorRecord({
    errorCode: "405",
    title: "Incorrect HTTP Method",
    message: "The request method is incorrect."
  }),
  500: ConnectErrorRecord({
    errorCode: "500",
    title: "Server Error",
    message: "Server has error. Please try later."
  })
};

export { CONNECT_ERRORS };
